const NotamachineAllReleasesStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/6guHBxRr1BVszzT7TwlC6N?si=68c91bb7ec1344cd" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-GyyxDhzpIwTOfwwP-zw68rg-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Lugosi - girlinmyphone 2 (feat. riley west)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5nv1RP7DRNoUYXodpyYuYU?si=5a6eb1efec1b4d62" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0213e5396fe4b85d93edfe0f4d" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>intro</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/423k3xZf4ClZsHZSzToQPK?si=0980122a117c42c2" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0213e5396fe4b85d93edfe0f4d" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>#1</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0l0JPJxQH0UoK92iSsrOaz?si=6e10d53cfb574d35" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0213e5396fe4b85d93edfe0f4d" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>#2</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2oR0boxnkHIpfDfQaplNfG?si=b1946de4f20e4e4c" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0213e5396fe4b85d93edfe0f4d" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>#3</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0bJUzGTXYYgsdm7USjeOlF?si=7d8914cc59e643e8" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0213e5396fe4b85d93edfe0f4d" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>reveal</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0OZdlw6Pq0t8BciQL5HdTO?si=6e0f305440944abe" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0213e5396fe4b85d93edfe0f4d" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>all my &#x3C;3</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0BozRtRGfFJNQG1oLBTZoq?si=8d02b7e44ea049a6" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0213e5396fe4b85d93edfe0f4d" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>nostalgia's dream</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1J1daOJI5SfjWHKNMfMixR?si=b58143c1f1b9486c" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0213e5396fe4b85d93edfe0f4d" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>headache, slow down</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/4mgxXe2LCeclJxYodLzsN8?si=83580a4ab35e46a5" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-Eyq0reGx3y8HFZz4-zEkbzQ-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Lugosi - girlinmyphone</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/07moCJwHJAlE2XFA096hIG?si=db13ae9aa8134039" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-Eyq0reGx3y8HFZz4-zEkbzQ-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Lugosi - girlinmyphone [NIGHTCORE]</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/3VgT0XFHN8QrqiKl66LTqp?si=5a2bff7b43034a49" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-Eyq0reGx3y8HFZz4-zEkbzQ-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Lugosi - girlinmyphone [slow+reverb]</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/1L0PRWcS6Nn2Mza6LWekWR?si=3adabe495c364349" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-XYk9DaEBl32Lr8YR-otcFtg-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Lugosi - upmyprice</strong><br/>
                (prod. notamahcine & starsmp3)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/2sgPNpt2PFlW0Y4IiVUUFx?si=91b64ea224ad442b" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-4UPtWoc3Jkfm15ye-hQ4BTA-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Lugosi - upmyprice [NIGHTCORE]</strong><br/>
                (prod. notamahcine & starsmp3)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/3g84iSHpzN7UwVHbCDyROM?si=08a3313a666e4b71" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-HnXwvyVUppgOvdvH-ZzcIBw-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Josen - FDB2T</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0l5Gw96s1GbhacGEEbpoLt?si=149860c8fdd44831" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>dreaming</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3mvgIjJmjNOupGW8QxjA1x?si=b723a4caccfd4bb8" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>nobody</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/7uycHFQY57ASAt2go10Lpl?si=f8bee785f33444da" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>reserved</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2amTQs4Ieviga0NUkAyS8m?si=6c2aa0a4ff5b445e" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>dancer Pt. 2 (feat. Kawaii Ry)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6wb8ZW3yV16zTApejRtIad?si=32336834e1ea4db9" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>swimming</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2r7bInu3cvHboB82Ze0BkA?si=7c581cc1fcff41ea" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>dex's interlude (feat. Baredex)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5VZmNX2MMsCG3TXkG3IunL?si=519686df46354a69" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>broken (feat. Kawaii Ry & rileylol)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3bynKma6hU4muH3nViv434?si=2237b9c50aeb4082" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>eyes</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3E2cK3yOtcPRCroX7FYRrn?si=53afacd7182648b4" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>going</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6z38pj1KBtdSCdJhMT5Hpw?si=6e6abc52e2794bac" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>wake up</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4bDJzPQRY7a1tZd2eGcXTw?si=7410ea1564714ec9" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>morning</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1QRHkG7FR8AX9oi1WR7uz3?si=47c5a7f7038e4c3a" target="_blank" rel="noopener noreferrer"> 
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-RH61p4zyUz6bA5Yw-0pGeYQ-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>                
              <p class="gallery-text">
              <strong>wave to shore and maybe they'll see you</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1rVyEynCf0euqny2wjRRsT?si=22e25eaae1ae425f" target="_blank" rel="noopener noreferrer"> 
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-RH61p4zyUz6bA5Yw-0pGeYQ-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>                
              <p class="gallery-text">
              <strong>counting sheep</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1cdcEmdP2rmf7azwYRlZnx?si=64983b27a7004df7" target="_blank" rel="noopener noreferrer"> 
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-RH61p4zyUz6bA5Yw-0pGeYQ-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>                
              <p class="gallery-text">
              <strong>stream of unconsciousness</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4XwrbD4xpKOlres5EIvqUE?si=5cf1cf314e51417e" target="_blank" rel="noopener noreferrer"> 
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-RH61p4zyUz6bA5Yw-0pGeYQ-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>                
              <p class="gallery-text">
              <strong>notes on a wurli</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6UbcyZ9FWDdnN5ExpWbrbq?si=3c5de78311e741ab" target="_blank" rel="noopener noreferrer"> 
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-RH61p4zyUz6bA5Yw-0pGeYQ-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>                
              <p class="gallery-text">
              <strong>deteriorate</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2ENjkK6zhuhg0AYk9VJ12H?si=8de6883b4cdb45e5" target="_blank" rel="noopener noreferrer"> 
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-RH61p4zyUz6bA5Yw-0pGeYQ-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>                
              <p class="gallery-text">
              <strong>standby / and wait</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/658LhYRoD2v3cTsHSSmO3u?si=7eaa543734ff4a8e" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-vysq6TCvGjfQvuZC-0drVIg-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Josen - SCAT</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/liljosen/datdeuce-w-rich-illuminati-1" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-YfmfaLZdNiBk54CE-4h7z8g-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Josen - DATDEUCE</strong><br/>
                (prod. Rich illuminati & notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/2YmdhKWGJYCXIac7squOuu?si=c21e0948ab63433f" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02e1bdfe74ed812355f5f5fad9" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Kawaii Ry - So Close</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/3WauqkgkBitQdxT2WKLaU0?si=8d06b624fce74058" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02e1bdfe74ed812355f5f5fad9" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Kawaii Ry - So Close (Fast)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/liljosen/2doe-freestyle-prodnotamachine" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-HSvA1cca3yC3ntOG-CWLyZA-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Josen - 2DOE FREESTYLE</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/3FT3DY5LBNCPmtxnx49nnW?si=5ea25d9ffe6a4eaa" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d0000b273d115a6d73a264e22aef59bc0" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Tomali - 4NARCHY (feat. Ptown)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/5Ca40Z2xTMYnJ5ktfB3DFb?si=6b5cb61a29814ebc" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d0000b273867d00732f3a1b7aaaae9aa9" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Tomali - Northbeach (feat. Ptown & Swamiii</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5teiDAoXfvk01DfsLzTyNh?si=661e383ffa3e4ff6" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02e503f1aa754b23c993e3ab4a" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>parallax:</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4SqTAwF0hf7l34udkx4ddp?si=e1e10becb29b446e" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02e503f1aa754b23c993e3ab4a" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>someday:</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/23IOnBpuPdZwntyINljAmS?si=f56a548771f54ba8" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02e503f1aa754b23c993e3ab4a" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>heart atk:</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6PRTErX4k3YgEUEHPsXXvd?si=0d1636af56984afe" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02e503f1aa754b23c993e3ab4a" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>u got us:</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1bL8uqxt4CtTk6A0au6GAX?si=1dc7c7e79ba9490f" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02e503f1aa754b23c993e3ab4a" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>lost in your eyessss:</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/2BLUOaAUNOZC4pbmw0iwrL?si=43262d0592a94a7d" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02b9ff17fcd530916999d819a6" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Josen - WAKEUPDENiGEEK</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/6TlGO1N7o6fDPi33JlRGRR?si=731290fbfc564031" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-g0uVyurAIIE2seWI-l0vjSA-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Josen - DRILLBOWSKI</strong><br/>
                (prod. notamachine & Rich Illuminati)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/25DGi20DcsMZHL8UCkmxXF?si=a8b7d4e7e65b4b96" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0278fd9409884acfd0f39fabe9" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>CoryRay - 4 a Lifetime (feat. Rico Leone)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/1SZ0QWWosnbutwoVOZMDOp?si=c84b6242a7fc4055" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02165adc96751fcdfd89a71fb8" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Kawaii Ry - DALYDK</strong><br/>
                (prod. chris6lair & notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/scumboishit/have-no-dreams-notamachineprod-prodantar_wund00" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-ahavJsn4fwsgywGU-eJtT3A-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Scum Boi - have no dreams (feat. kurtwarnermovie)</strong><br/>
                (prod. notamachine, Antar & Wund)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5rFGxsBhT4TN99u0qoNDSN?si=3d5a498c923a4762" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02a7d33975f76d56a20163251b" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>fall</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/38YrKFKFLRU923EP5Dl96O?si=46a17cda8b8b4d12" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d0000b27335b7903e635582c019f3e082" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Lugosi - burn holes</strong><br/>
                (prod. notamachine & rjpasin)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/74XbWghfe7umH8kIsdQJVY?si=54eeb783a9b747b4" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d0000b27335b7903e635582c019f3e082" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Lugosi - goinoutsadv2</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/2war7lT6JfBZrlAuzOR7Bc?si=f4dde20fd4e7404e" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-rztihdDfLmZzgfl5-IDykQA-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Daria St. Clair - Pieces</strong><br/>
                (prod. notamachine & ROHO)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://open.spotify.com/track/4jEUhtplLJ4nqCgEtgvqWd?si=1453b24701bf44cd" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e020f5bb9160e67d5b178b8e069" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>isid or - all the sounds (notamachine remix)</strong><br/>
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://open.spotify.com/track/5oQMbDorntRCD9Y0wYXuAp?si=d983ef85ebd241e0" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e020f5bb9160e67d5b178b8e069" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Jedwill - placebo effect (notamachine remix)</strong><br/>
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://open.spotify.com/track/46GNeZiuPE67iFEgYE68iW?si=241f3219f56448c0" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e020f5bb9160e67d5b178b8e069" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>internetboy - skin care (notamachine remix)</strong><br/>
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://open.spotify.com/track/11UPjUSepAMxQVN7UkPOSV?si=4e72e9d8b8d34ed1" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e020f5bb9160e67d5b178b8e069" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>blissom - so far (notamachine remix)</strong><br/>
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://open.spotify.com/track/2SMLAFmAMBZljHgI55TBYp?si=b59791853f3b48d0" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e020f5bb9160e67d5b178b8e069" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Button Maker, billy ! & 1Booth - ENOUGH! (notamachine remix)</strong><br/>
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/1jeY1KAGYUobEegT0LVy4x?si=5109dd14ea9a4bec" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-Gu6OVaO4vhT4lHEK-GylG5A-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Kawaii Ry - Hope You Don't</strong><br/>
                (prod. Rich Illuminati & notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/7tb64UVOARyAbQyIReaR4n?si=b5f836548ba8417c" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-Gu6OVaO4vhT4lHEK-GylG5A-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Kawaii Ry - Rockstar Wasted</strong><br/>
                (prod. gotti & notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/3IhCkp0pe3KNpimBr5vWYr?si=75dad82cc0764a3c" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-mNjoZfs4ncaHSVx0-83Gnmw-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Kawaii Ry - Late (feat. Lil Dujour)</strong><br/>
                (prod. Meauxminy & notamachine)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/1a6AkDSELN9zj8LhcXnkAu?si=341722a5b10a40ee" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-mNjoZfs4ncaHSVx0-83Gnmw-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Kawaii Ry - Love is Dead</strong><br/>
                (prod. notamachine, antar & 1wireshark)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/6M7DgI8n3DR8zvo8cZ8oXz?si=c88fe36e5e174fd3" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-mNjoZfs4ncaHSVx0-83Gnmw-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Kawaii Ry - God Complex</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/4lanKESHOVSShxc9OQRHYh?si=4e0bc0ede4f34e86" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d00001e02d22b78e993fd00183366b4b6" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>sphere merchants - trust</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/0uO0Qosc5WYTfBjPi5x466?si=ded88831c62f4e41" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Clown</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/3IAym27cx48RClaaVPghKA?si=b9532f9724fe412c" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Battle Bus (feat. Lil Dujour)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/45eev9YzAniaNF9bgyqyn8?si=1017582b25774fc2" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - It's Me</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/2BIrMMXBlknKNhscZOwrLG?si=855e5f8d22a44ac8" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Don't Wait On Me II</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/4NpTXoV5k39TEPsxWUMaAb?si=54b25bf9cac04398" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Due Time</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/2MAfiUDgKAhfvvD8GS9PUe?si=6e0edac5d99943d0" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Firefight</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/4OTMVKBesbX2ro17DfE2Ke?si=0409e375d3354d11" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Folder</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/7M98tFfeZZpPWghv4YTHoN?si=d0beeec085004371" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - My Weed</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/5MFzQ5UCpnAYycgzybFkZV?si=595062485ebf4273" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Scoop</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/17ulPTVLeXnirBCGWvwp6f?si=c9416311568c4e8b" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Money Called</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/3eD07yn0xIZCEux6CvequI?si=ad02750dffae4b97" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Twizzy (feat. Rileylol)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/5HYuriuAaQLqXzOKFObaxg?si=76eba43232f44032" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Follow The Lead</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/0tHeaM2h00oF2ENmetcIzV?si=52b864d9a54547a0" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Watches</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/4XmqGJR6rmTmZFHXeK6czn?si=03ecd747da1d4424" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Yes No Maybe</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/2mF8iIquaFdCK41bobEJuV?si=ad01060b0ec545b0" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Body Shop</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/57PCMEmvSTispedM3yZzn1?si=a7d22874325a40b7" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Would Your Rather</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/2u1XRHa9HRGr5os98iTE21?si=68d6045ae23f4a81" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Stop! Look!</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/4aZJiqQvn2EBp860EouMxR?si=a289c0fe4184483d" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Top Geek</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2fHsutbgrRGYSrFJVZZX6V?si=6b85741ea955425a" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02b4005588bc8f2d1de3f3eb4d" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>pt i</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/25UlkXqFHvwxPeGZhokNa8?si=a0ac72e67a304531" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02b4005588bc8f2d1de3f3eb4d" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>birdsongs</strong><br/>
                (feat. Kawaii Ry)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3V50ZTDDET86sQo9gKwFfF?si=cf0bd3d342094f3c" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02b4005588bc8f2d1de3f3eb4d" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>enjoy yourself</strong><br/>
                (feat. Kawaii Ry & Lugosi)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3D22ziOgyplsGFDLkUFR7H?si=d97c4e405064475d" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02b4005588bc8f2d1de3f3eb4d" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>pt ii</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6f0wOhCOhyz8S7pR5HiZGj?si=b6f34406a5b741d2" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02b4005588bc8f2d1de3f3eb4d" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>faded</strong><br/>
                (feat. Lugosi)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/4C1UNfTBBlsstOX9rzuApo?si=95915470b7b3435b" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-il9NATXFnn8xquQe-onkrAQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - No Keys</strong><br/>
                (prod. Meauxminy & notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/25k48bpEDxUU3LMQ0q6uO6?si=1a2c9b34686c4b85" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d00001e02aeaa139bee1c1cac5c780898" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Tomali & Ptown - ALL4LUV</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/3e3W86Cl96swaxTbv96Z2a?si=bcef856fdf6a44e8" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d00001e02aeaa139bee1c1cac5c780898" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Tomali & Ptown - BEN10</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/4lanKESHOVSShxc9OQRHYh?si=4e0bc0ede4f34e86" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d00001e02d22b78e993fd00183366b4b6" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>sphere merchants - trust</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/0uO0Qosc5WYTfBjPi5x466?si=ded88831c62f4e41" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Clown</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/3IAym27cx48RClaaVPghKA?si=b9532f9724fe412c" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Battle Bus (feat. Lil Dujour)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/45eev9YzAniaNF9bgyqyn8?si=1017582b25774fc2" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>It's Me</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/2BIrMMXBlknKNhscZOwrLG?si=855e5f8d22a44ac8" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Don't Wait On Me II</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/4NpTXoV5k39TEPsxWUMaAb?si=54b25bf9cac04398" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Due Time</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/2MAfiUDgKAhfvvD8GS9PUe?si=6e0edac5d99943d0" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Firefight</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/4OTMVKBesbX2ro17DfE2Ke?si=0409e375d3354d11" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Folder</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/7M98tFfeZZpPWghv4YTHoN?si=d0beeec085004371" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>My Weed</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/5MFzQ5UCpnAYycgzybFkZV?si=595062485ebf4273" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Scoop</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/17ulPTVLeXnirBCGWvwp6f?si=c9416311568c4e8b" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Money Called</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/3eD07yn0xIZCEux6CvequI?si=ad02750dffae4b97" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Twizzy (feat. Rileylol)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/5HYuriuAaQLqXzOKFObaxg?si=76eba43232f44032" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Follow The Lead</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/0tHeaM2h00oF2ENmetcIzV?si=52b864d9a54547a0" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Watches</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/4XmqGJR6rmTmZFHXeK6czn?si=03ecd747da1d4424" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Yes No Maybe</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/2mF8iIquaFdCK41bobEJuV?si=ad01060b0ec545b0" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Body Shop</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/57PCMEmvSTispedM3yZzn1?si=a7d22874325a40b7" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Would Your Rather</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/2u1XRHa9HRGr5os98iTE21?si=68d6045ae23f4a81" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Stop! Look!</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/4aZJiqQvn2EBp860EouMxR?si=a289c0fe4184483d" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wck162Bv3CofOVwy-oJLtzQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Top Geek</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2fHsutbgrRGYSrFJVZZX6V?si=6b85741ea955425a" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02b4005588bc8f2d1de3f3eb4d" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>pt i</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/25UlkXqFHvwxPeGZhokNa8?si=a0ac72e67a304531" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02b4005588bc8f2d1de3f3eb4d" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>birdsongs</strong><br/>
                (feat. Kawaii Ry)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3V50ZTDDET86sQo9gKwFfF?si=cf0bd3d342094f3c" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02b4005588bc8f2d1de3f3eb4d" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>enjoy yourself</strong><br/>
                (feat. Kawaii Ry & Lugosi)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3D22ziOgyplsGFDLkUFR7H?si=d97c4e405064475d" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02b4005588bc8f2d1de3f3eb4d" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>pt ii</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6f0wOhCOhyz8S7pR5HiZGj?si=b6f34406a5b741d2" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02b4005588bc8f2d1de3f3eb4d" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>faded</strong><br/>
                (feat. Lugosi)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/4C1UNfTBBlsstOX9rzuApo?si=95915470b7b3435b" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-il9NATXFnn8xquQe-onkrAQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - No Keys</strong><br/>
                (prod. Meauxminy & notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/25k48bpEDxUU3LMQ0q6uO6?si=1a2c9b34686c4b85" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d00001e02aeaa139bee1c1cac5c780898" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Tomali & Ptown - ALL4LUV</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/3e3W86Cl96swaxTbv96Z2a?si=bcef856fdf6a44e8" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d00001e02aeaa139bee1c1cac5c780898" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Tomali & Ptown - BEN10</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/6s1JmW3MXAb2BH9jFi8w13?si=604dfba0a31f48e2" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b273f2f2bf001f382b16315b7ac3" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry & Lugosi - Remy Truck</strong><br/>
                (prod. Remy3D & notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/7BWuJJD9fvbpqQ8HRTePPj?si=7ec43658dba6437a" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273200c87078b070d6ac16a2bdc" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Heems - Take Me (The Heights) (feat. Josen)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/4mX5Cv2hxmb820ZIWhEeXj?si=cc1439f22d784f54" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02eb6ed43d5b7a864793e53697" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Craze</strong><br/>
                (prod. notamachine, Semaj & noahmejia)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/7lKZTXW3Or4Ldyzq06ohCv?si=dfa1d947664744d2" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02eb6ed43d5b7a864793e53697" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Sorry Not Sorry</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/1OkAqk181H4cBxlRI47LjU?si=51fca0bcb8114226" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02eb6ed43d5b7a864793e53697" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Like '08 & MySpace</strong><br/>
                (prod. notamachine & AntarNSA)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/1Eog4N1duEm6BpapbqmiwF?si=b11a81e24e764186" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02eb6ed43d5b7a864793e53697" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Lakeside</strong><br/>
                (prod. notamachine, teo domani & inflxble)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/liljosen/drill-la-drill-intro-album" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-sSsPf8mp1dbUConC-10EJAg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Josen - Drill La Drill (Intro)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/6n4uvRv2VsNpGPuVHrNRzP?si=49f4a00ed6154764" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273ce6f569a4fc1d7bc5fa20a14" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Loudpak Shawty - Slow It Down</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6f0wOhCOhyz8S7pR5HiZGj?si=b6f34406a5b741d2" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273baf9695f125261f9cecc3f90" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>dont4getme</strong><br/>
                (feat. Kawaii Ry)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/last-weekend-prod-notamachine-joeleytrick" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-IEsDz7OWY1WNEHKM-kRQDhQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Last Weekend</strong><br/>
                (prod. notamachine & Joe Leytrick)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/1nmmEsDbD37rdqfk08G5uI?si=547f012e4c6b4835" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-aPzQtNEpZZ9vfZFQ-8gqmoA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - U2TH</strong><br/>
                (prod. notamachine & depart)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/1q4Kf0FEfS3UXsXg9WzGyb?si=815d1f87776c4e38" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-aPzQtNEpZZ9vfZFQ-8gqmoA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Coup de Grace</strong><br/>
                (prod. notamachine & kvse)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/0AZeoMyTf3jX5fPqcLuRTO?si=3a2e808374c74d39" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-aPzQtNEpZZ9vfZFQ-8gqmoA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - HP</strong><br/>
                (prod. notamachine, depart & 1mvgnolia)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/4qYH2UURO65Led2Sfq3B1T?si=b5b8efb740a94fa4" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-aPzQtNEpZZ9vfZFQ-8gqmoA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Hittin' Different</strong><br/>
                (prod. notamachine, depart & ryanbevelo)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/7mOYd1ttL4T0yBdg8QvJrU?si=e48ba773052e4a45" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-aPzQtNEpZZ9vfZFQ-8gqmoA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Hullbreaker</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/4NPZqZsrp6oUx9nG64nnkk?si=7a9428086d93494a" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-aPzQtNEpZZ9vfZFQ-8gqmoA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - My Cup</strong><br/>
                (prod. notamachine & kaishigui)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/6GOYZrzUYyxqF7BTiXA99x?si=58af8bff623e4adb" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-aPzQtNEpZZ9vfZFQ-8gqmoA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Hope This Never Ends</strong><br/>
                (prod. notamachine, antar & jacktxt)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/cant-believe" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-N9Ay8ThifqkFOruy-iurflg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Can't Believe</strong><br/>
                (prod. notamachine & prodmitchell1)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/smokin-ganj-in-the-saint-laurent-prod-notamachine-depart-lodoni" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-se0MVGyDOi849ltY-53i1DA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Smokin' Ganj In The Saint Laurent</strong><br/>
                (prod. notamachine, depart & lodoni)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/6ZamekFJYHEtWJHNG0cnjp?si=4a5c0b57f8ea452a" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b273fc0c69c5d2911d6c36ae1837" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>chet - need ur luv</strong><br/>
                (prod. Chris6lair & notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/eleven-prod-notamachine-nightmare-freezepop" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-kThfbKvF8b7190lf-OusyVQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Eleven</strong><br/>
                (prod. notamachine, nightmare & freezepop)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/fruity-peebbbles-53122-455-pm" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-KKiZ1NmLLzlGvNPx-o64N4Q-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Fruity Pebbles</strong><br/>
                (prod. notamachine, depart & dynoxmusic)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/off-it-prod-notamachine" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-3oINC0l3ccyLiIg2-j7IoTQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - OFF IT</strong><br/>
                (prod. notamachine & Baredex)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/its-working-prod-notamachine-gotti" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-yp6bmxZENq3T3t0c-cgzXAw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - It's Working...</strong><br/>
                (prod. notamachine & Gotti)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://open.spotify.com/track/7yW9WO384xyDp0UrB58q4g?si=b84fbb8270514bd7" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-bSn7x6Ssylq1SLKi-pFqxUQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Button Maker, 1booth & billy ! - ENOUGH!</strong><br/>
                (notamachine Remix)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/silence-open-amincmaj-151bpmprod-notamachine-joe-leytrick" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-Rx9sm1kcWYHl6eLY-LYuD0Q-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Silence (feat. Jackie Platinum)</strong><br/>
                (prod. notamachine & Joe Leytrick)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/the-spot-prod-notamachine-horuhe-san-mitchell?in=kawaiiry/sets/one-left" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Q4zox4LUoIM5aTyY-vfsBrg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - the spot</strong><br/>
                (prod. notamachine, horuhe san & Mitchell)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/empty-the-bank-prod-notamachine-horuhe-san-beat-nutz?in=kawaiiry/sets/one-left" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Q4zox4LUoIM5aTyY-vfsBrg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - empty the bank</strong><br/>
                (prod. notamachine, horuhe san & Beatnutz)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/dont-wait-on-me-prod-notamachine" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-QbXT8DAWeJKslcgo-p9zfcA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - DONT WAIT ON ME</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/6-days-prod-bleachh-x-notamachine" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-JV5gTbocgcCq9Jzm-3ti4zA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - 6 Days</strong><br/>
                (prod. Bleachh & notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/queued-up-prod-notamachine" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-maT9lRt2BBtnMwg3-jZ4VKQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Queue'd Up</strong><br/>
                (prod. notamachine & Depart Beats)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/5t4r5h1p5-prod-notamachine" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-maT9lRt2BBtnMwg3-jZ4VKQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Starships</strong><br/>
                (prod. notamachine & Itsjohnnyvio)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/love-in-the-air-prod-notamachine" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-maT9lRt2BBtnMwg3-jZ4VKQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Love in the Air</strong><br/>
                (prod. notamachine & Adam Eazy)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/eyes-locked-no-words-prod-notamachine" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-maT9lRt2BBtnMwg3-jZ4VKQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - We'll Run Past the Trees</strong><br/>
                (prod. notamachine & Joe Leytrick)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/eyes-locked-no-words-prod-notamachine" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-maT9lRt2BBtnMwg3-jZ4VKQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Eyes Locked, No Words</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/doubted-on-me-prod-notamachine-joeleytrick" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-hhN7CKiYzgb6y8rN-z2Nwag-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Doubted On Me</strong><br/>
                (prod. notamachine & Joe Leytrick)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/ladder" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-jGHURlKWau5V54WY-vbxzOA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Ladder</strong><br/>
                (prod. notamachine & Joe Leytrick)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/more-prod-notamachine-1" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-peLtxGRRN3BvaKbZ-cqJr6w-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - More</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/paper-cut-prod-notamachine-kvse" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-L7bPe60si0Uq3APA-dq22gw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Paper Cut</strong><br/>
                (prod. notamachine & Kvse)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/who-got-the-loud-pack-prod-notamachine-bleachh" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-I59BrE7dJeupJIL2-7yzyeA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Who Got That Loud Pack?</strong><br/>
                (prod. notamachine & Bleachh)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6dRGdQJTzygvMZj3mAugrN?si=bbb74617f06c4e92" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27399e29f3e25ade7308f057c76" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>towards the light:</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/47uiAgSgJS3NNrFJFCiuUy?si=85c4799a0cb84028" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27399e29f3e25ade7308f057c76" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>just met you:</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3mgd2r2C5Q2xezD6vuJP55?si=ce6e4fe347744d6c" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27399e29f3e25ade7308f057c76" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>talking to a ghost:</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3PYgVWQZQNaUdOqPwv4sdF?si=16a06727131d4f84" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27399e29f3e25ade7308f057c76" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>elevator interlude:</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/54il6aeYrp6u4rfwNICLQL?si=93b18be55ed54fd5" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27399e29f3e25ade7308f057c76" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>relax:</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/creed-prod-notamachine-x-kal" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-ySGDb77ncikjS3Kg-G0K2wQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Creed</strong><br/>
                (prod. notamachine & Kalpierce)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/7h7wrA3aJKbQPEsOwmmgkP?si=49324de67de24105" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27376392ac8b005bd240a515bc7" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Ditch The Ego - HIGH ON LIFE (feat. Curt Summers)</strong><br/>
              (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5IbSlBgXWVTg4iDX8Ektmn?si=3ed46c4be3fc4f24" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27397d3098af36de69b81c9f7ac" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>DANCER (feat. Kawaii Ry)</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/gremlin-prod-notamachine-gotti" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-U6SOdW1tFlB0pcSw-Ly4zwA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Gremlin</strong><br/>
                (prod. notamachine & Gotti)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/2XluvJYRDQY5IuQHcgDbKM?si=17ed282ebdcb46dc" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-VKox1o1QdhHLOGSk-9Eg0VQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - You're Done (I'm Numb)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/37L5hH4o2rwZyc6yYFwau1?si=86d31b10ae5b461f" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-VKox1o1QdhHLOGSk-9Eg0VQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Thought at 4AM IV</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/2rnq2CHQSBJtV4CZdqmNCU?si=5426352e5f004fd9" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-VKox1o1QdhHLOGSk-9Eg0VQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - How Romantic</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/3DOaOX1AODmHOy7eflxg5D?si=6deae251adbb4951" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-VKox1o1QdhHLOGSk-9Eg0VQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Walker Texas Ranger</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/4Ri6UbbairLR8rFrah4JOa?si=11edda4cc4564010" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b2737e17a0d5db24958b17dd8796" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Loudpak Shawty - Lessons</strong><br/>
              (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4slOcnhSNAnJrxR1fAdK7c?si=e6869695664b464b" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27334a304d134ddf7a087b707ca" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>fomo</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5VmFIGc0luHSWgcPrBQLeR?si=b3da5ec0f5a94f56" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27334a304d134ddf7a087b707ca" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>ghost emoji</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1O7rAzWwnPjsKmmxos2NdB?si=55f1244dffc24988" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27334a304d134ddf7a087b707ca" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>hyperactivity (seven seconds)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1NrpZsAOiCfVqhLlsPggFF?si=3f5f52023e2d4f57" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27334a304d134ddf7a087b707ca" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>here for a good time</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5RHOncgKkpK1cPmqVRxw4m?si=48ec102269f14b11" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27334a304d134ddf7a087b707ca" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>irl</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6AGKtRwDjjj1nonfVpZyTb?si=ba1d82605d1a4dc9" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27334a304d134ddf7a087b707ca" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>artificial</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/1uhziAQj1AEcaKaEFwusf2?si=a169d56f53674d2a" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273e5500bf1957cc6dd8cd9155b" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>uglyboy - drown</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://soundcloud.com/notamachineprod/skinny-love-notamachine-remix" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-ezHsyWu4zSvmpsBR-M47n8g-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Bon Iver - Skinny Love</strong><br/>
              (notamachine Remix)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/0W0Ly7VoZER6ndZA3Xu7mz?si=13879c5edc624ba5" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-M0Rzq7jdHWKlMJHT-ormDZw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - thats right baby</strong><br/>
                (prod. notamachine & Uncle Beat Productions)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/7jWtCaPR3clpHhpAkq2iau?si=d49ec62b206a4a02" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273163e23fa19c3b086a4580b7f" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Button Maker - WRATH</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>   

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/1I44gwUuJyRXxuP1vp6JFQ?si=ec6174192bd341f9" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273194a8d46291067ad062d1077" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Loudpak Shawty - Don't Matter (feat. Lugosi)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>            

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/hellscapedigital/josen-cooj-prod-notamachine-hsd-exclusive" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-tdFV2ZdrsTjcq4Ia-JUzzIQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Josen - COOJ!</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/6WHilxGt1Y5YCw7Sbov0bb?si=916ef2a4cc334346" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27391489dca51abe2193bffb88f" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Salem Riin - TRAPPIN OUT THE BANDO (feat. Loudpak Shawty)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://open.spotify.com/track/7qSgp4mnLc1XlRxMl0aEVt?si=dd57166cb45d4be2" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273ddc7c82c96ddddf69728761a" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>mothgirl - body carving</strong><br/>
                (notamachine Remix)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/20ZvpeJuz3Nv6VCwjpYdxu?si=736967b16df64b7f" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-t4xSwCgh2Slp1ZDi-MjaU2g-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Shoulda Coulda Woulda</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/6Q3CMGaJ7U4RYaMercDoVB?si=8ee5cde9ef4a4ceb" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-t4xSwCgh2Slp1ZDi-MjaU2g-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Elevate the Sound</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/0LaWojZpVqT4W9vE9yItEv?si=8844be206cd34705" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-t4xSwCgh2Slp1ZDi-MjaU2g-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Love Me // Hurt Me</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/7mifwW2B9Xz7OkxM5sDQQs?si=5eb6c8fbdeb341af" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-t4xSwCgh2Slp1ZDi-MjaU2g-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Genre Bender</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/1v55mPUMBGvTo5BNFzOpyI?si=32b33f8e937d4f5e" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-t4xSwCgh2Slp1ZDi-MjaU2g-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Switch it Up</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://open.spotify.com/track/2eE162PF1piUQXAkrjAo30?si=f91f892b70114a3e" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b2732e3282c641ee817ec953de42" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Button Maker - PENALTY GAME</strong><br/>
                (notamachine Remix)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/5ZILUO9y9wuIkB3ApRJHgS?si=bac3abb7bab64d65" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27375c9323eb18b7e3f01773af7" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Loudpak Shawty - Blast Off</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/pop-out-prod-notamachine-joeleytrick" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-6W9ZxX1f6ftK1kyN-QJvKjA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Pop Out</strong><br/>
                (prod. notamachine & Joeyletrick)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/5LcUCE05tDky7pouGUztQQ?si=ce9d37e13cc5443f" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273ab034d279838dd1788e2289a" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Ditch The Ego - LIVING ALIVE</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/0J498wuUO5igICCisquTyw?si=2fc64c74d4f94250" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27364a960be4159e7cdd3b55248" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Loudpak Shawty - No More</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Collab</p>
            <a href="https://open.spotify.com/track/206S6JSiu82uJHrFUlPgHO?si=397f3d9f5f524900" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b2736b1fa672ff7d77495b694bad" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Last Will - Family Matters</strong><br/>
                (prod. Last Will & notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/5Mp0ilGSm9ooaX52fhGlme?si=ff0ff3c6449e44b1" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273b0e720f8efeaa0211b5f30f8" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Salem Riin - DIZZY</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/4P0rU7TLY4czJzVJEH8Z1D?si=04ee33530c63457d" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27327eeee7b0a3966fa0ef8bcc2" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Salem Riin - IM SORRY</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/1HjF7iWVJ2Z7VqjWOnLWnY?si=c579581eb5da4997" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-6yTCkFzKMGrNXQz9-zTvYtQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Few Thangs</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/7BngQc0OFivT9wWEWB8dzS?si=bb0e3e00013245fc" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-6yTCkFzKMGrNXQz9-zTvYtQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Tidal Wave</strong><br/>
                (prod. notamachine & Joeyletrick)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/7HUPQHAdzMFDMNnw5i5pPO?si=7da0e4720138453f" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-6yTCkFzKMGrNXQz9-zTvYtQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Best Place Possible</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/1J83kVNUWGSct6AH5mEZwZ?si=f895739cc1dd407d" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-6yTCkFzKMGrNXQz9-zTvYtQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Locket</strong><br/>
                (prod. notamachine & Depart Beats)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/50whAVwGRa84gDZPEF5z5K?si=df49506bc873478e" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-6yTCkFzKMGrNXQz9-zTvYtQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Royal Flush</strong><br/>
                (prod. notamachine & Joeyletrick)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/burn-me-down-notamachine-remix" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-S8eeBrZFa7LCL6FE-awy4YA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Burn Me Down</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/scoreboard-prod-notamachine-couple-milli" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-mLSl1cRhmwiOLeZq-J9HyUQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Score Board</strong><br/>
                (prod. notamachine & Couple Milli)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/3u1JdCwdmP04gZOpOCmaNU?si=07ab2211c70940c7" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-EsnzJHwsi1a6bU7B-3hVvnQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Element</strong><br/>
                (prod. notamachine, realayvah & hayleeswrld)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/572A6YPDFX2f1sQ01PXMYu?si=b357ce3185714a22" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-y6kYvvJF00JPoUKT-GEzVRg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Hell Hounds</strong><br/>
                (prod. notamachine & Gotti)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Collab</p>
            <a href="https://open.spotify.com/track/3cUbZmRD205pJvIdn7fGcX?si=222584c9c52f4e29" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27304e7f11ab00e950401059eab" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>skybourneDee - Lifeline</strong><br/>
                (prod. skybourneDee & notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Collab</p>
            <a href="https://open.spotify.com/track/6O4i75QqIZOitULXFeiQgg?si=c077ebfbf5674223" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27304e7f11ab00e950401059eab" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>skybourneDee - Foreign Whip</strong><br/>
                (prod. skybourneDee & notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Collab</p>
            <a href="https://open.spotify.com/track/4RmGpbpP7VEzUZ901b0QPm?si=2541d47be226423a" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27304e7f11ab00e950401059eab" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>skybourneDee - Alone Together</strong><br/>
                (prod. skybourneDee & notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Collab</p>
            <a href="https://open.spotify.com/track/3VWsK5vxZu7qWI56oyxy7M?si=49da0f56356c4c36" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27304e7f11ab00e950401059eab" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>skybourneDee - The Mood</strong><br/>
                (prod. skybourneDee & notamachine)
              </p>
            </a>
          </div>      

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/3VGbZfhZ4qsi5rrSIQ3u5d?si=9ecb669e951a4d03" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273ffc2052a46911c7be5fd2923" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Ditch The Ego - LIFE IS NEVER EASY</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>  

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/3bhSonEyLIORCPYmLBuMeH?si=d7b753957bba409e" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273157fa927081a7afdbe239f65" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Loudpak Shawty - Peaceful Nightmares</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/49qY2D3glma3WKwgDUV6MO?si=02feaeef7d674678" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273bd07d2e3d1e60ffdd790df34" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Ditch The Ego - THANK THE UNIVERSE</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/3ezlM7TGgIsq7GVl84OA83?si=3a24c8e5f3f74ed4" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Zy2efuUGXKFOmrQy-zGctQw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Demi Lovato</strong><br/>
                (prod. notamachine & Couple Milli)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/3S93HLTSA5r5aF8sRZzG5q?si=5061c18cb0184192" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Zy2efuUGXKFOmrQy-zGctQw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Think About Me For a Second</strong><br/>
                (prod. Semaj & notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/7ieo2NFP7JvKOvA3dlVl2X?si=ffff8e0c587f4ecf" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Zy2efuUGXKFOmrQy-zGctQw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Bad News Bears</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Collab</p>
            <a href="https://open.spotify.com/track/0DEtUjmC4m82B27gCNiuYy?si=a103eb0557784c9c" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-WTUSGCOp2VPFpQnM-31pPfA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Last Will - Slow Down</strong><br/>
                (prod. Last Will & notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/78hLBUzh4OGPnQXP8RIXjo?si=cd9255ccf0144314" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b2730645f153e35445ba89b674ec" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Loudpak Shawty - How I'm Comin'</strong><br/>
              (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/1EYNHN6xUW574eRmvSXbCG?si=68f6806871c445be" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b2730645f153e35445ba89b674ec" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Loudpak Shawty - LOML</strong><br/>
              (prod. notamachine)
              </p>
            </a>
          </div>          

        </div>
      </>
    );
  };
  export default NotamachineAllReleasesStatic;